// «Телефон по запросу» для OLX-объявлений: очередь и кэш живут в воркере (D1),
// пока ПК выключен запрос копится, обработчик (contact:drain на ПК) закроет его
// и пушнёт уведомление ботом.

import WebApp from '@twa-dev/sdk';
import type { ContactState } from '@barter/shared';
import { API_BASE } from './api-base';

function authHeaders(): Record<string, string> {
  try {
    const initData = WebApp.initData;
    if (initData) return { Authorization: `tma ${initData}` };
  } catch {}
  return {};
}

export type ContactRequestResult =
  | { status: 'pending' }
  | { status: 'fetched'; phone: string }
  | { status: 'denied' };

export async function requestContact(adId: string): Promise<ContactRequestResult> {
  const res = await fetch(`${API_BASE}/contact-request`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...authHeaders() },
    body: JSON.stringify({ adId }),
  });
  if (!res.ok) throw new Error(`HTTP ${res.status}`);
  return (await res.json()) as ContactRequestResult;
}

export async function fetchContactState(adId: string): Promise<ContactState> {
  const res = await fetch(`${API_BASE}/contact?adId=${encodeURIComponent(adId)}`);
  if (!res.ok) throw new Error(`HTTP ${res.status}`);
  return (await res.json()) as ContactState;
}
